import { useMutation } from '@apollo/client';
import DELETE_USER_CONTENT_SHARE_SUBSCRIPTION from 'graphql/mutations/userContentShareSubscriptions/DeleteUserContentShareSubscription.graphql';

export default function useDeleteUserContentShareSubscriptionMutation() {
  return useMutation(DELETE_USER_CONTENT_SHARE_SUBSCRIPTION);
}
